import React, { Component } from 'react';
import DocumentCard from 'Components/cards/DocumentCard';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    getReportNames
} from 'Apis/reportApi.js';

import './OperationsReports.scss';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';

export class OperationsReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportData: [],
            currentValues: '',
            isLoading: false,
        };
        this.attachBindings();
    }

    attachBindings() {
        this.getReportData = this.getReportData.bind(this);
        this.viewReportPage = this.viewReportPage.bind(this);
        this.getDocumentCard = this.getDocumentCard.bind(this);
    }

    componentDidMount() {
        localStorage.setItem('isProductReportView',false); 
        this.getReportData();
    }

    getReportData() {
         this.setState({
             isLoading: true,
         });
         let acquirerList=getAcquirerAccessList();
         return getReportNames(acquirerList)
           .then((apiResponse) => {
             const reportData = apiResponse.data;
             this.setState({
               reportData: reportData,
               isLoading: false,
             });
           })
           .catch((error) => {
              this.setState({ reportData: [], isLoading: false });
             console.log('Error Occured while fetching report data', error);
           });
    }

    viewReportPage(report) {
        const { reportName,acquirerCode, pageListId, reportId } = report;
        const keywords = ['Daily Inventory Report', 'Missing Pre-Note Cases'];
        const includesInventoryReport = keywords.some(keyword => reportName.includes(keyword));
        const pathname = includesInventoryReport 
            ? `/reports/inventory/${reportId}` 
            : `/reports/view/${reportId}`;
        const state = { reportName, acquirerCode, pageId: pageListId ,reportId };
        this.props.history.push({ pathname, state });
    }

    getDocumentCard(reports) {

        return (
            <div className="card-list">
                {
                    reports.map((report) => {
                        return (
                            <DocumentCard
                                key={report.reportId}
                                title={report.reportName}
                                primaryAction={() => {
                                    this.viewReportPage(report);
                                }}
                                primaryActionText='View Report'
                                secondaryOptions={[]}
                                document={report}
                                isReportIcon={true}
                            >
                            </DocumentCard>
                        );
                    })
                }
            </div>
        );
    }

    get reportCards() {
        return (
            <section className="reports-container">
                <div className={this.props.isSearchActive ? 'main-content--header secondary-header' : "main-content--header "} style={{zIndex :2}}>
                    <h1>Operations Reports</h1>
                </div>
                <span className="operation-reports" style={{paddingTop: this.props.isSearchActive ? "20px" : "84px"}}>
                    {
                        this.getDocumentCard(this.state.reportData)
                    }

                </span>
            </section >
        );
    }

    render() {
        window.document.title = 'Operations Reports';
        return (
            <section className="reports-container">
                {
                    (!this.state.isLoading) ? (
                        this.reportCards) :
                        (
                            this.state.isLoading && (
                                <div className="ball-sync-loader loader" style={{ height: 200, backgroundColor: 'white' }}>
                                    <BVLoader20 />
                                </div>
                            )
                        )
                }
            </section>
        );
    }
}

OperationsReports.propTypes = {

};

OperationsReports.defaultProps = {

};
const mapStateToProps = (state)  => ({
    isSearchActive: state.appSearch.isSearchActive,
});
  
const mapDispatchToProps = (dispatch) => {
return {
    setSearchOpenFlag: (isSearchActive) => {
        dispatch(setSearchOpenFlag(isSearchActive));
    },
};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OperationsReports));
